import React from 'react';
import PropTypes, { object, string } from 'prop-types';
import { components } from 'react-select';
import { useTranslation } from 'react-i18next';

import classes from './MenuListPart.module.scss';

import { Text } from '../../../Elements';

const MenuListPart = props => {
  const counterSelectOptions = props.selectProps.value.length;
  const { limit } = props.selectProps;
  const { t } = useTranslation(['activity']);

  return (
    <>
      <components.MenuList {...props}>{props.children}</components.MenuList>
      {limit && (
        <Text type="p" className={classes.counterWrap}>
          <Text size={4} className={classes.counter}>
            {counterSelectOptions}
          </Text>
          <Text className={classes.text}>{t('activity:filters.FROM')}</Text>
          <Text size={4} className={classes.counter}>
            {limit}
          </Text>
        </Text>
      )}
    </>
  );
};

MenuListPart.propTypes = {
  isSelected: PropTypes.bool,
  options: PropTypes.oneOfType([
    PropTypes.arrayOf(string),
    PropTypes.arrayOf(object)
  ]),
  data: PropTypes.oneOfType([PropTypes.arrayOf(object), PropTypes.object]),
  isMulti: PropTypes.bool,
  selectProps: PropTypes.object,
  children: PropTypes.array
};

export default MenuListPart;
